
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 27.149 39.955"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#C51F75","d":"M1.555 19.512A13.054 13.054 0 010 13.319C0 5.964 6.077 0 13.575 0c7.497 0 13.574 5.964 13.574 13.318 0 2.237-.562 4.344-1.554 6.194l-12.02 20.443z"}}),_c('path',{attrs:{"fill":"#fff","stroke":"#fff","stroke-width":".25","d":"M6.945 6.429c-.96 0-1.73.78-1.73 1.73v9.26c0 .95.77 1.73 1.73 1.73h13.26c.96 0 1.73-.78 1.73-1.73v-9.26c0-.95-.77-1.73-1.73-1.73zm13.26 13.36H6.945a2.37 2.37 0 01-2.37-2.37v-9.26c0-1.3 1.06-2.37 2.37-2.37h13.26c1.3 0 2.37 1.06 2.37 2.37v9.26c0 1.3-1.06 2.37-2.37 2.37z"}}),_c('path',{attrs:{"fill":"#fff","d":"M22.215 16.789h-17.3v1h17.3zm-15.27-8.72h1v-1.64h-1zm4.99-1.92h-1v2h1zm4 .08h-1v2h1zm4-.16h-1v2h1z"}}),_c('path',{attrs:{"fill":"#fff","d":"M7.945 19.289v-1.67h-1v1.67zm3.99-1.83h-1v2h1zm4 0h-1v2h1zm3-.06v2h1v-2zm-5.79-5.52v1.8l1.34-.93zm-.57 2.91v-4l3 1.95zM4.815 7.739v1h17.3v-1z"}})])
          )
        }
      }
    